export default {"src":"/_next/static/media/plant-icon.fd7b4d44.svg","height":39,"width":38,"blurWidth":0,"blurHeight":0};